import FilteringComponent from './FilteringComponent';

export default FilteringComponent;



// WEBPACK FOOTER //
// ./src/js/shared/filter/index.js